import React, { Component } from 'react'
import { Message, Grid, Button, Divider, Modal } from 'semantic-ui-react'
import result from 'lodash.result'
import Main from '../../Main'
import AccordionList from './AccordionList'
import Loading from './../../module/Loading';
import { API_GET_DATA_QUEUE, API_RELEASE_USER } from '../../api'
const DEFAULT_ERROR = 'Unknown error, please try again later'

export default class EditVerify extends Component {
  constructor(props){
    super(props);
    this.state = {
      userData: {
        groups: [{
          fields: []
        }]
      },
      errorMsg: null,
      modalMsg: null,
      modalOpen: false,
      modalColor: 'red',
      loading: true
    }
  }

  initialUserData(userId) {
    API_GET_DATA_QUEUE(userId)
      .then((response) => {
        console.log(response.data)
        this.setState({ userData: response.data, loading: false })
      })
      .catch((err) => {
        this.setState({ errorMsg: result(err, 'response.data.message', DEFAULT_ERROR) })
      })
  }

  componentDidMount() {
    const userId = this.props.match.params.userId
    this.initialUserData(userId)
  }

  /* =========================================
  :: Handle Function
  ==========================================*/

  handleVerifyButton = () => {
    const { userData } = this.state

    let paramReleas = {
      userId: userData.userId
    }

    API_RELEASE_USER(paramReleas)
      .then(() => {
        this.setState({ modalOpen: true, modalMsg: 'Success Verified', modalColor: 'green' })
        this.initialUserData()
      })
      .catch((error) => {
        console.log(error.response)
        //this.setState({ modalOpen: true, modalMsg: error.response.data.message, modalColor: 'red' })
      });

    window.scrollTo(1000, 0);
  }

  handleModalClose = () => this.setState({ modalOpen: false })

  enableModalError = () => {
    this.setState({ modalOpen: true, modalMsg: 'Proses Gagal', modalColor: 'red' })
  }

  /* =========================================
  :: Render
  ==========================================*/

  render() {
    const { userData, errorMsg, modalMsg, modalOpen, modalColor, loading } = this.state
    const filterGroup = userData.groups
      .filter( field => field.groupName === 'KTP' ||  field.groupName === 'Biometrik' )
      .filter( field => field.groupStatus !== 'new')

    if (errorMsg) { return <Main><Divider horizontal>{errorMsg}</Divider></Main> }
    if (loading) { return <Main><Loading /></Main> }

    return (
      <Main>

        {/* Modal Info */}
        <Modal basic size='mini' open={modalOpen} onClose={this.handleModalClose} >
          <Modal.Content className="pf-txt-center">
            <h4 style={{color: '#fff'}}>{modalMsg}.</h4>
          </Modal.Content>
          <Modal.Actions>
            <Button color={modalColor} onClick={this.handleModalClose} inverted>Close</Button>
          </Modal.Actions>
        </Modal>

        <h1 className="site__content__header">User Data Verification {errorMsg}</h1>

        {/* Header Info */}
        <Message info>
          <Grid stackable>
            <Grid.Row>
              <Grid.Column width={8} >
                <p>
                  <strong>User ID</strong> : {userData.userId}
                  <br/>
                  <strong>Name</strong> : {userData.fullName}
                  <br/>
                  <strong>Phone</strong> : {userData.phone}
                </p>
              </Grid.Column>
              <Grid.Column width={8} >
                <p>
                  <strong>Last Updated</strong> : {result(userData, 'verificationEvent.lastUpdated')}
                  <br/>
                  <strong>Updated By</strong> : {result(userData, 'verificationEvent.verificatorName')}
                </p>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Message>

        {/* Data Accordion */}
        <AccordionList
          propsButtonVerify={this.handleVerifyButton}
          enableModalError={this.enableModalError}
          propsUserID={userData.userId}
          propsGroup={filterGroup}
        />

      </Main>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/component/Verification/EditVerify.js